import React from 'react';

import { Box } from '@adsk/alloy-react-box';

const ReferencePickerTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <Box typography="heading3">{children}</Box>;

export default ReferencePickerTitle;
